/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { gridSize } from '@atlaskit/theme';

export const Content = styled.div({
  margin: `${gridSize() * 2}px 0`,
  minWidth: '400px',
});

export const ButtonGroup = styled.div({
  marginTop: `${gridSize() * 3}px`,
});
